import { useSearchParams } from "features/shared/hooks/useSearchParams";

export const useProformaInvoiceIdParam = (): string | undefined => {
  // hooks
  const searchParams = useSearchParams();
  
  // helpers
  const getProformaInvoiceId = (): string | undefined => { 
    let proformaInvoiceId = searchParams.get("proformaInvoiceId");
    if (proformaInvoiceId != null) {
      return proformaInvoiceId;
    }

    return undefined;
  }

  // return
  return getProformaInvoiceId();
}